import * as React from "react";

import { cn } from "@/lib/chillnn/cn";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
	return (
		<div className="relative">
			<input
				type={type}
				className={cn(
					"flex h-10 w-full rounded-md border border-zinc-200 bg-white px-3 py-2 text-sm ring-offset-white",
					"placeholder:text-zinc-500/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2",
					"disabled:cursor-not-allowed disabled:opacity-50",
					className,
				)}
				{...props}
				ref={ref}
			/>
		</div>
	);
});
Input.displayName = "Input";

export { Input };
